import { PropsWithChildren } from 'react';

import { ModuleContext } from './ModuleContextProvider.context';
import { ModuleContextState } from './ModuleContextProvider.types';

export type ModuleContextProviderValue = ModuleContextState;

export const ModuleContextProvider = <C extends ModuleContextState>({
  children,
  value,
}: PropsWithChildren<{ value: C }>) => {
  return <ModuleContext.Provider value={value}>{children}</ModuleContext.Provider>;
};
